import Centro_DialiseService from '../../services/Centro_DialiseService'

const state = () => ({
    loadingCentros_Dialises: false,
    centro_dialise: null,
    centros_dialises: [],
    total: 0,
    pages: 0,
    page: 1,
    stateSearch: {
        name: '',
        sigla: ''
    },
    totalCentrosByState: null,
})
  
const mutations = {
    SET_CENTRO_DIALISE: (state, payload) => {
        state.centro_dialise = payload
    },
    SET_CENTROS_DIALISE: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.centros_dialises = payload.items
        }else{
            state.centros_dialises = [...state.centros_dialises, ...payload.items]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_CENTROS_DIALISE: (state, payload) => {
        state.loadingCentro_Dialise = payload
    },
    SET_EVENTS_STATE_SEARCH: (state, payload) => {
        state.stateSearch = payload;
    },
    SET_TOTAL_CENTROS_BY_STATE: (state, payload) => {
        state.totalCentrosByState = payload;
    },
}

const actions = {
    async fetchCentro_Dialise({commit}, id){
        try{
            commit('SET_LOADING_CENTROS_DIALISE', true)
            const response = await Centro_DialiseService.getOne(id);
            commit('SET_CENTRO_DIALISE', response.data)
            commit('SET_LOADING_CENTROS_DIALISE', false)
        } catch (error) {
            commit('SET_LOADING_CENTROS_DIALISE', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchCentros_Dialises({commit}, params = {}){
        try{
            commit('SET_LOADING_CENTROS_DIALISE', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await Centro_DialiseService.get(keyword, pageNumber, pageSize, order);
            commit('SET_CENTROS_DIALISE', response.data)
            commit('SET_LOADING_CENTROS_DIALISE', false)
        } catch (error) {
            commit('SET_LOADING_CENTROS_DIALISE', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchTotalCenntrosByState({commit}){
        try{
            commit('SET_LOADING_CENTROS_DIALISE', true)
            const response = await Centro_DialiseService.getTotalByState();
            commit('SET_TOTAL_CENTROS_BY_STATE', response.data)
            commit('SET_LOADING_CENTROS_DIALISE', false)
        } catch (error) {
            commit('SET_LOADING_CENTROS_DIALISE', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchCentrosByState({commit}, params = {}){
        try{
            commit('SET_LOADING_CENTROS_DIALISE', true)
            const { uf = null, keyword = '', pageNumber = 1, pageSize = 12 } = params;
            const response = await Centro_DialiseService.getByState(uf, keyword, pageNumber, pageSize);
            commit('SET_CENTROS_DIALISE', response.data)
            commit('SET_LOADING_CENTROS_DIALISE', false)
        } catch (error) {
            commit('SET_LOADING_CENTROS_DIALISE', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getCentro_Dialise: state => state.centro_dialise,
    getCentros_Dialises: state => state.centros_dialises,
    getLoadingCentro_Dialise: state => state.loadingCentro_Dialise,
    getCentroDialiseStateSearch: state => state.stateSearch,
    getTotalCentrosByState: state => state.totalCentrosByState,
}

export default {
    state,
    getters,
    mutations,
    actions
};